<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
  </div>
</template>

<script>
//script
import Tools from "../../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../../scripts/Global";
import QuestionSelect from "../../cmp/questionSelect";

export default {
  data() {
    return {
      data: {
        // headTipImg: '苏尚卿讲解',
        headTipTxt: "都让你选它了",
        headTipPathTxt: "",
        headTipPath: "/",

        qText: "走了这么久累了吧？今天很开心，这个礼物送给你！",
        errText: "走了这么久累了吧？今天很开心，这个礼物送给你！",
        // sideImg: '贵妃',
        answerArr: [
          {
            txt: "选我选我",
            right: true,
            type: "reload"
          },
          {
            txt: "选它选它",
            type: "reload"
          }
        ]
      }
    };
  },
  components: {
    QuestionSelect
  },
  created() {
    window.Global.startPlay("ytx", "scene11");
  },
  computed: {},
  methods: {
    jump(event) {
      if (event) {
        Global.yubi.ytx.b4 = true;
      }

      let headTipPath = "";
      if (Object.keys(Global.yubi.ytx).length >= 4) {
        headTipPath = "/bonus?giftRoad=ytx";
      } else {
        headTipPath = "/result";
      }
      Global.curr = {
        ...this.data,
        headTipImg: "cv-04",
        headTipTxt: "其实，最好的礼物就是你",
        headTipPath,
        headTipPathTxt: "走吧！ >>",
        ybtxt: "",
        textCfg: {
          "text-align": "center"
        },
        bg: "澄瑞亭",

        ybResultImg: "杨",
        ybResultHTML: `<p>玩得开心吗？</p>
        <p>但我们没收集到4枚玉璧，不能抽奖了，没事，有你就很好。</p>
        <p>
         你可以继续挑战本关，也可以让我的其他伙伴陪你哦~
        </p>`
      };

      if (event) {
        window.Global.startPlay("ytx", "scene12");
        this.$router.replace("/yu");
      } else {
        setTimeout(() => {
          window.Global.startPlay("ytx", "scene13");
        }, 200);
        this.$router.replace("/result");
      }
    },
    finish(event) {
      if (event) {
        Global.yubi.ytx.b4 = true;
      } else {
      }
    }
  }
};
</script>

 
<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/澄瑞亭.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
